import clsx from "clsx";

import type { FilterOptions } from "common/types";

import type React from "react";

interface FilterButtonProps {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

function FilterButton({ isActive, onClick, children }: FilterButtonProps) {
  return (
    <button
      type="button"
      className={clsx(
        "rounded-full px-3 py-2 text-button-xs transition-colors",
        isActive
          ? "bg-black-900 text-white"
          : "bg-black-100 text-black-900 hover:bg-black-200",
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

const FILTER_OPTIONS = [
  { id: "all", label: "All" },
  { id: "favorite", label: "Favorite" },
  { id: "unread", label: "Unread" },
] as const;

interface ConversationFiltersProps {
  filteredBy: FilterOptions;
  setFilteredBy: (filter: FilterOptions) => void;
}

export default function ConversationFilters({
  filteredBy,
  setFilteredBy,
}: ConversationFiltersProps) {
  return (
    <div className="flex flex-row gap-2">
      {FILTER_OPTIONS.map((option) => {
        const { id, label } = option;

        return (
          <FilterButton
            key={id}
            isActive={filteredBy === id}
            onClick={() => setFilteredBy(id)}
          >
            {label}
          </FilterButton>
        );
      })}
    </div>
  );
}
